import React from 'react';
import { Select } from '@chakra-ui/react';
import { services } from './App/data';

export const ServiceSelect = ({ onChange, disabled, newService }) => (
	<Select name="service" {...{ onChange, disabled }}>
		{Object.keys(services).map(key => (
			<option key={key} value={key} selected={key === newService}>
				{services[key]}
			</option>
		))}
	</Select>
);
